import { __awaiter } from "tslib";
import { getCookie } from '@avalara/bat-apps-shared/helpers/cookies';
import sessionStorage from '@avalara/bat-apps-shared/helpers/sessionStorage';
import fetch from '../fetch';
import analytics from '../analytics';
import conf from '../../conf';
import { setOffer } from '../../store/offer';
import { setDiscountPercent, setOfferSpecificSettings } from '../../store/order';
import { setBuySuccess } from '../../store/avatax-signup';
import { authRedirect, basePostParams, } from './index';
import { trackAvataxPurchase, trackOfferPurchaseAnalytics, updateProductAnalytics, } from './analytics';
import { getSystemErrorMessaging } from './error';
import { embeddedViewRequested, getWindowQueryUnlessInProd, getOfferByActiveFlow, getAnalyticsByActiveFlow, getOfferMetadataByActiveFlow } from '../helpers';
import { formatPrice } from '../../../shared/helpers';
import { getTotalCost } from '../buy-flow';
import { getOrderTotal, getSelectedPlan, getValidatedConnectorId } from '../../selectors/order';
import { selectReturnsPricingData } from '../../selectors/returns';
import localStorage from '../local-storage';
import { createAccountWithOffer } from './accounts';
import { goToNextOfferStep } from './offer-flow';
import { Pages, } from '../../../shared/types/offers';
import { setFetchStatus } from '../../store/system';
const addOfferToAccount = (params) => __awaiter(void 0, void 0, void 0, function* () {
    const { dispatch, state, paymentToken, path } = params;
    const { account, data } = state;
    if (account.accountId == null)
        return Promise.resolve({ ok: false, status: 400, message: 'No account id' });
    const postBody = {
        accountId: account.accountId,
        offer: getOfferByActiveFlow(state, paymentToken),
        marketingData: data.marketingData,
        info: getOfferMetadataByActiveFlow(state),
    };
    const postParams = Object.assign(Object.assign({}, basePostParams), { body: JSON.stringify(postBody) });
    return fetch(dispatch)(`${conf.API_URL}/api/accounts${path}`, postParams);
});
export const addPaidAvataxTier = ({ paymentToken, history, }) => (dispatch, getState) => __awaiter(void 0, void 0, void 0, function* () {
    const { account, buyFlow } = getState();
    if ((getCookie('TESTCAFE_E2E'))) {
        history.push('/buy/success');
        return;
    }
    const result = yield addOfferToAccount({ dispatch, state: getState(), paymentToken, path: '/offers/avatax' });
    if (!result.ok) {
        dispatch(getSystemErrorMessaging({ errorCode: 'signupError', msg: 'We were unable to set up your AvaTax tier.', serverMsg: result.message, isPaid: true }));
        return;
    }
    if (result.value.unauthenticatedUser === true) {
        authRedirect();
        return;
    }
    const { eventName, data } = getAnalyticsByActiveFlow(getState());
    analytics.track(eventName, data);
    if (account.accountId == null)
        return;
    const { accountId } = account;
    localStorage.set(`paidAvataxOrBundlePurchase-${accountId}`, 'true');
    trackAvataxPurchase({
        selectedTier: buyFlow.selectedTier,
        connector: account.connector,
        price: getTotalCost(buyFlow),
    });
    history.push('/buy/success');
    dispatch(setBuySuccess());
});
export const addReturnsOffer = ({ history, paymentToken: paymentMethodId, handleError = () => { }, }) => (dispatch, getState) => __awaiter(void 0, void 0, void 0, function* () {
    const state = getState();
    const { account: { accountId }, data: { marketingData }, order: { discountName }, system: { activeFlow }, } = state;
    if ((getCookie('TESTCAFE_E2E'))) {
        history.push('/returns/thank-you');
        return;
    }
    if (accountId == null)
        return;
    const { totalPrice } = selectReturnsPricingData(state);
    const postBody = {
        accountId,
        activeFlow,
        discountName,
        marketingData,
        paymentMethodId,
        setupReturnsLink: `${conf.CUP_URL}/cup/a/${accountId}/returns-provisioning`,
        totalPrice,
    };
    const postParams = Object.assign(Object.assign({}, basePostParams), { body: JSON.stringify(postBody) });
    const query = getWindowQueryUnlessInProd();
    const result = yield fetch(dispatch)(`${conf.API_URL}/api/accounts/offers/returns${query}`, postParams);
    if (!result.ok || result.value.unauthenticatedUser === true) {
        dispatch(getSystemErrorMessaging({ errorCode: 'signupError',
            msg: 'We were unable to set up your returns subscription.',
            serverMsg: 'message' in result && typeof result.message === 'string' ? result.message : '',
            isPaid: true,
        }));
        handleError();
        return;
    }
    const { eventName, data } = getAnalyticsByActiveFlow(getState());
    analytics.track(eventName, data);
    dispatch(updateProductAnalytics('purchase'));
    history.push('/returns/thank-you');
});
export const purchaseOffer = (history, paymentMethodId) => (dispatch, getState) => __awaiter(void 0, void 0, void 0, function* () {
    const state = getState();
    const { account: { accountId, isLoggedIn }, data: { marketingData }, offer: { offerFlow, offerName, pages }, order: { discountCode, offerSpecificSettings, quantity, selectedPlanName, salesTax }, system: { inProgressFetches }, } = state;
    if (!isLoggedIn) {
        dispatch(createAccountWithOffer(history, paymentMethodId));
        return;
    }
    const hasPurchasedOffer = sessionStorage.get('hasPurchasedOffer') === 'true';
    if (accountId == null || !offerFlow)
        return;
    if (inProgressFetches.purchaseOffer || hasPurchasedOffer)
        return;
    dispatch(setFetchStatus({ fetchName: 'purchaseOffer', inProgress: true }));
    const selectedPlan = getSelectedPlan(state);
    if (!selectedPlanName || !selectedPlan)
        return;
    const currency = selectedPlan.currency || undefined;
    const postBody = {
        marketingData,
        discountCode,
        offerFlow,
        offerSpecificSettings,
        quantity,
        totalCost: formatPrice(getOrderTotal(getState()), 2, currency),
        paymentMethodId,
        selectedPlanName,
        connectorId: getValidatedConnectorId(state),
        salesTax,
    };
    const postParams = Object.assign(Object.assign({}, basePostParams), { body: JSON.stringify(postBody) });
    const searchParams = new URLSearchParams(window.location.search);
    const result = yield fetch(dispatch)(`${conf.API_URL}/api/accounts/offers?${searchParams}`, postParams);
    dispatch(setFetchStatus({ fetchName: 'purchaseOffer', inProgress: false }));
    if (!result.ok || result.value.unauthenticatedUser) {
        analytics.track('ADD_OFFER_TO_EXISTING_ACCOUNT_FAILURE', {
            accountId,
            offerId: offerFlow,
        });
        dispatch(getSystemErrorMessaging({ errorCode: 'signupError',
            msg: `We couldn’t finish adding ${offerName} to your account.`,
            serverMsg: 'message' in result && typeof result.message === 'string' ? result.message : '',
            isPaid: true,
        }));
        if (embeddedViewRequested()) {
            window.parent.postMessage({ event: 'add-offer', success: false, type: offerFlow }, '*');
        }
        return;
    }
    if (embeddedViewRequested() && !pages.includes(Pages.SettingUp)) {
        window.parent.postMessage({ event: 'add-offer', success: true, type: offerFlow }, '*');
    }
    sessionStorage.set('hasPurchasedOffer', 'true');
    dispatch(trackOfferPurchaseAnalytics(offerFlow, accountId, false));
    dispatch(goToNextOfferStep({ history }));
});
export const validateDiscountCode = (flow, discountCode) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    if (!flow)
        return;
    const result = yield fetch(dispatch)(`${conf.API_URL}/api/accounts/discount/${flow}/${discountCode}`);
    if (!result.ok)
        return;
    dispatch(setDiscountPercent(result.value));
});
export const addRiskAssessmentOffer = ({ history, paymentToken: paymentMethodId, handleError = () => { }, }) => (dispatch, getState) => __awaiter(void 0, void 0, void 0, function* () {
    const { account: { accountId }, data: { marketingData }, system: { activeFlow }, order: { discountCode }, } = getState();
    if (accountId == null)
        return;
    const postBody = {
        accountId,
        activeFlow,
        marketingData,
        offer: getOfferByActiveFlow(getState(), paymentMethodId),
        paymentMethodId,
        discountCode,
    };
    const postParams = Object.assign(Object.assign({}, basePostParams), { body: JSON.stringify(postBody) });
    const result = yield fetch(dispatch)(`${conf.API_URL}/api/accounts/offers/risk-assessment`, postParams);
    if (!result.ok || result.value.unauthenticatedUser === true) {
        dispatch(getSystemErrorMessaging({ errorCode: 'signupError',
            msg: 'We were unable to set up your Sales Tax Risk Assessment.',
            serverMsg: 'message' in result && typeof result.message === 'string' ? result.message : '',
            isPaid: true,
        }));
        handleError();
        return;
    }
    const { eventName, data } = getAnalyticsByActiveFlow(getState());
    analytics.track(eventName, data);
    dispatch(updateProductAnalytics('purchase'));
    history.push('/risk-assessment/thank-you');
});
const getOfferSpecificQueries = (offerSpecificQueryParams = {}) => (dispatch) => {
    const searchParams = new URLSearchParams(window.location.search);
    const offerSpecificQueries = Object.keys(offerSpecificQueryParams).reduce((queries, key) => (Object.assign(Object.assign({}, queries), { [key]: searchParams.get(offerSpecificQueryParams[key]) })), {});
    dispatch(setOfferSpecificSettings(offerSpecificQueries));
};
export const fetchOffer = (offerFlow) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const result = yield fetch(dispatch)(`${conf.API_URL}/api/offers/${offerFlow}${window.location.search}`);
    if (result.ok) {
        const clientDetails = result.value;
        dispatch(getOfferSpecificQueries(clientDetails.offerSpecificQueryParams));
        dispatch(setOffer(clientDetails));
    }
    else {
        dispatch(setOffer(null));
        if (result.status !== 404) {
            dispatch(getSystemErrorMessaging({ errorCode: 'genericError' }));
        }
    }
});
